import { render, staticRenderFns } from "./TimetableWrapper.vue?vue&type=template&id=2fcb3a6c&scoped=true&"
import script from "./TimetableWrapper.vue?vue&type=script&lang=js&"
export * from "./TimetableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TimetableWrapper.vue?vue&type=style&index=0&id=2fcb3a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb3a6c",
  null
  
)

export default component.exports